import type { ApiRoute, NoBody, NoQueryParams } from "../../../api"
import type { DosOfferOverviewView } from "./DosOfferOverviewView"

export interface GetOfferOverviewPathParams {
	inventoryId: string
}

export const getOfferOverviewRoute: ApiRoute<
	GetOfferOverviewPathParams,
	NoQueryParams,
	NoBody,
	DosOfferOverviewView | "irrelevant" | null
> = {
	buildUrl: (params) => `vehicles/${params.inventoryId}/offer-overview`,
	method: "get",
	path: "/vehicles/:inventoryId/offer-overview",
}
